module.exports = __webpack_public_path__ + "static/media/70-warren.29859935.JPG";